module.exports = __webpack_public_path__ + "img/advantage1.19c48f6e.svg";